import { LogLevel } from "angular-auth-oidc-client";

export const environment = {
    protocol: 'https:',
    production: true,
    wsBaseUrl: 'https://coreglobus.innovactors.it',
    auth: {
        authority:  'https://auth.innovactors.it/realms/app-prod-globusg',
        clientId: 'globusg',
        redirectUri: 'https://globus.innovactors.it',
        loglevel: LogLevel.Warn
    }
};
